import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "i-preloader__item" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "g-row g-row--appearance_spaced g-row--space_md g-row--space_xl-xl" }
const _hoisted_4 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_7 = { class: "g-row g-row--justify_end" }
const _hoisted_8 = { class: "g-cell" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_11 = { class: "error-label" }
const _hoisted_12 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_13 = { class: "error-label" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_input = _resolveComponent("control-input")!
  const _component_modal_trigger = _resolveComponent("modal-trigger")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_control_button = _resolveComponent("control-button")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, { onSubmit: $setup.submitForm }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["i-preloader", { 'is-active': $setup.isLoad }])
      }, _hoisted_2, 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($setup.phoneCodes.length)
            ? (_openBlock(), _createBlock(_component_control_input, {
                key: 0,
                component: "ControlPhone",
                name: "username",
                "max-height": 190,
                errors: errors,
                "input-label": _ctx.$t("Номер телефону"),
                codes: $setup.phoneCodes,
                "predefined-code": $setup.phoneCodes[0],
                rules: "required|maskedPhone:8",
                modelValue: $setup.formdata.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.username) = $event)),
                "onCode:changed": $setup.setCountryCode
              }, null, 8, ["errors", "input-label", "codes", "predefined-code", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_control_input, {
            name: "password",
            errors: errors,
            "input-label": _ctx.$t("Пароль"),
            type: "password",
            rules: "required|min:8|max:32|repeatSymbols:3",
            modelValue: $setup.formdata.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formdata.password) = $event))
          }, null, 8, ["errors", "input-label", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_modal_trigger, {
                component: "Modals/Authentication/PasswordForgot",
                classes: ['modal--size_xs']
              }, {
                default: _withCtx(({ open }) => [
                  _createElementVNode("span", {
                    class: "ds-link ds-link--size_sm ds-link--hover_underline ds-link--color_text-1",
                    onClick: _withModifiers(open, ["prevent"])
                  }, _toDisplayString(_ctx.$t("Забули пароль?")), 9, _hoisted_9)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_VeeError, { name: "non_field_errors" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(message), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_VeeError, { name: "recaptcha" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("ReCaptcha -")) + " " + _toDisplayString(message), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_control_button, {
            disabled: $setup.isLoad,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Увійти")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}